<template>
  <div
    class="m-auto h-screen w-96 max-w-7xl flex justify-center align-middle flex-col"
  >
    <div class="text-4xl text-white mx-auto mb-8 text-center">
      {{ $t("ssosbk.activation.setpassword.title") }}
    </div>
    <p class="mx-auto mb-10 text-xl">
      {{ $t("ssosbk.activation.setpassword.text") }}
    </p>
    <password-element
      id="password"
      type="password"
      :label="$t('ssosbk.activation.setpassword.password')"
      required
      :error-message="passwordError"
      class="input-primary w-full mb-2"
      @update-field="(value) => (password = value)"
    />
    <password-element
      id="password-repeat"
      type="password"
      :label="$t('ssosbk.activation.setpassword.passwordRepeated')"
      required
      :error-message="passwordRepeatedError"
      class="input-primary w-full mb-2"
      @update-field="(value) => (passwordRepeated = value)"
    />
    <SingleAccordion
      :title="$t('ssosbk.register.passwordGuidelinesTitle')"
      class="mt-3 mx-auto"
    >
      {{ $t("ssosbk.register.passwordGuidelines") }}
    </SingleAccordion>
    <button
      class="button-bkk-100 w-fit mx-auto mt-8 !text-background"
      @click="submitPassword"
    >
      {{ $t("ssosbk.activation.setpassword.submit") }}
    </button>
  </div>
</template>

<script>
import SingleAccordion from "../layout/SingleAccordion.vue";
import PasswordElement from "../form/PasswordElement.vue";

export default {
  name: "ActivateSetPassword",
  components: { PasswordElement, SingleAccordion },
  props: {
    open: Boolean,
  },
  emits: ["onSubmit"],
  data() {
    return {
      password: null,
      passwordRepeated: null,
      passwordError: null,
      passwordRepeatedError: null,
    };
  },
  methods: {
    submitPassword() {
      this.passwordError = null;
      this.passwordRepeatedError = null;
      if (this.password !== this.passwordRepeated) {
        this.passwordRepeatedError = "Die Passwörter stimmen nicht überein.";
      }

      if (!this.validatePassword(this.password)) {
        this.passwordError =
          "Das Passwort entspricht nicht den Passwort Richtlinien.";
      }

      if (this.passwordError === null && this.passwordRepeatedError === null) {
        this.$emit("onSubmit", this.password);
      }
    },

    validatePassword(value) {
      const regex =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

      return regex.test(value) && value !== null;
    },
  },
};
</script>
